import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnSalesBySlp } from '@utils/columns'
import Layout from '@components/Layout'
import { useNavigate } from 'react-router-dom'
import { debouncedSet } from '@utils/debounce'
import { useQuery } from '@tanstack/react-query'
import { fetchSalesBySlpSalesRole } from '@utils/fetchData'
import { getToday } from '@utils/time'
import { formatNumberWithSpaces } from '@utils/numberWithSpaces'
import SalesByDateModal from '@components/Modal/SalesBySlpModal/SalesByDate'
import { useSelector } from 'react-redux'
import ClientsDebtSalesModalSlp from '@components/Modal/SalesBySlpModal/SalesByDateAndManagerSlp'

const MySales = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const formattedDate = getToday()

	const getMe = useSelector((state) => state.main.getMe)

	const [slpName, setSlpName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [pageSize] = useState(100)
	const [currentPage, setCurrentPage] = useState(0)

	const [viewModalOpen, setViewModalOpen] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const { data = [], isLoading } = useQuery({
		queryKey: [
			'salesBySlp',
			startDate,
			endDate,
			pageSize,
			currentPage,
			getMe.salesPersonCode,
		],
		queryFn: fetchSalesBySlpSalesRole,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleViewClick = (record) => {
		setSelectedRowData(record)
		setViewModalOpen(true)
	}

	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleNextPage = () => {
		if (data.length === pageSize) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const columns = columnSalesBySlp(t, handleViewClick)

	return (
		<Layout>
			<Header
				title={'salesBySlp'}
				hasMoreData={data.length === pageSize}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
			/>
			<ClientsDebtSalesModalSlp
				visible={viewModalOpen}
				onClose={() => setViewModalOpen(false)}
				data={selectedRowData}
			/>
		</Layout>
	)
}

export default MySales
